import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Provider } from 'react-redux';

import store from './store/store';

import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import { ScrollToTop } from './components/ui/router-link/RouterLink';

import Home from './pages/home/Home';
import About from './pages/about/About';
import Eyeglasses from './pages/eyeglasses/Eyeglasses';
import LensBuilder from './pages/eyeglasses/lens-builder/LensBuilder';
import HighLights from './pages/highlights/HighLights';
import ContactUs from './pages/contact-us/ContactUs';
import Product from './pages/product/Product';
import Cart from './pages/cart/Cart';
import Checkout from './pages/checkout/Checkout';
import CheckoutComplete from './pages/checkout/checkout-complete/CheckoutComplete';
import { ScreenLoader } from './components/ui/index';
import Help from './pages/help/Help';
import ShippingReturn from './pages/help/shipping-return/ShippingReturn';
import TermAndCondition from './pages/help/terms-and-condition/TermAndCondition';
import Faq from './pages/help/faq/Faq';
import Favorites from './pages/favorites/Favorites';

function App() {
  return (
    <Provider store={store}>
      <Router>
        <ScrollToTop />
        <Header />
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/about" component={About} />
          <Route exact path="/mens" render={() => <Eyeglasses gender="Men" />} key="men-frames" />
          <Route
            exact
            path="/women"
            render={() => <Eyeglasses gender="Women" key="women-frames" />}
          />
          <Route
            exact
            path="/unisex"
            render={() => <Eyeglasses gender="Unisex" key="unisex-frames" />}
          />
          <Route exact path="/eyeglasses" render={() => <Eyeglasses key="all-frames" />} />
          <Route exact path="/eyeglasses/:id" component={LensBuilder} />
          <Route exact path="/product" component={Product} />
          <Route exact path="/highlights" component={HighLights} />
          <Route exact path="/contactus" component={ContactUs} />
          <Route exact path="/cart" component={Cart} />
          <Route exact path="/checkout" component={Checkout} />
          <Route exact path="/checkout/completed" component={CheckoutComplete} />
          <Route exact path="/help" component={Help} />
          <Route exact path="/shipping-returns" component={ShippingReturn} />
          <Route exact path="/cgs" component={TermAndCondition} />
          <Route exact path="/faq" component={Faq} />
          <Route exact path="/favorites" component={Favorites} />
        </Switch>
        <Footer />
        <ScreenLoader></ScreenLoader>
      </Router>
    </Provider>
  );
}

export default App;
